/* ==========================================================================
   ACG Car Show — Submit a Show
   Posts straight to Supabase PostgREST. The key here is the publishable/anon
   key, which is safe to ship: RLS on car_show_submissions grants anon INSERT
   of pending rows only — no read access, and no way to self-approve.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init(root) {
    var url = root.dataset.endpoint;
    var key = root.dataset.key;
    var form = root.querySelector('[data-submit-form]');
    var msg = root.querySelector('[data-submit-msg]');
    var done = root.querySelector('[data-submit-done]');
    var btn = root.querySelector('[data-submit-btn]');
    var again = root.querySelector('[data-submit-again]');
    var hp = root.querySelector('[data-submit-hp]');

    if (!form || !url || !key) return;

    function say(text, kind) {
      msg.textContent = text;
      msg.className = 'acg-submit__msg acg-submit__msg--' + kind;
      msg.hidden = false;
    }

    function clean(v) {
      return typeof v === 'string' && v.trim() ? v.trim() : null;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.hidden = true;

      // Honeypot: bots fill every field they find, humans never see this one.
      if (hp && hp.value) {
        done.hidden = false;
        form.hidden = true;
        return;
      }

      if (!form.reportValidity()) return;

      var f = new FormData(form);
      var website = clean(f.get('website'));
      if (website && !/^https?:\/\//i.test(website)) website = 'https://' + website;

      var payload = {
        name: clean(f.get('name')),
        show_type: f.get('show_type') || 'car_show',
        start_date: f.get('start_date'),
        end_date: clean(f.get('end_date')),
        city: clean(f.get('city')),
        state: clean(f.get('state')),
        country: clean(f.get('country')) || 'US',
        street: clean(f.get('street')),
        website: website,
        contact_name: clean(f.get('contact_name')),
        contact_email: clean(f.get('contact_email')),
        notes: clean(f.get('notes')),
        user_agent: navigator.userAgent.slice(0, 400)
      };

      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Submitting…';

      fetch(url + '/rest/v1/car_show_submissions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: key,
          Authorization: 'Bearer ' + key,
          Prefer: 'return=minimal'
        },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (r.ok) {
            form.hidden = true;
            done.hidden = false;
            done.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          return r.json().then(function (d) {
            // 23505 is the unique index catching a repeat of the same show
            if (d && (d.code === '23505' || /duplicate key/i.test(d.message || ''))) {
              say('We already have that show on file — thanks for looking out for us.', 'ok');
            } else if (r.status === 401 || r.status === 403) {
              say('We could not accept that submission. Please email us and we will add it by hand.', 'err');
            } else {
              say((d && d.message) || 'Something went wrong. Please check the dates and try again.', 'err');
            }
          });
        })
        .catch(function () {
          say('We could not reach the server. Please check your connection and try again.', 'err');
        })
        .then(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });

    if (again) {
      again.addEventListener('click', function () {
        form.reset();
        form.hidden = false;
        done.hidden = true;
        msg.hidden = true;
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Can't submit a show that already happened.
    var start = form.querySelector('[name="start_date"]');
    if (start) {
      var t = new Date();
      start.min = t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
    }
  }

  ready(function () {
    document.querySelectorAll('[data-acg-car-show-submit]').forEach(init);
  });
})();
